<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="150">
                <FormItem :label="$t('org_cname')">
                    <Input v-model="org_cname" :placeholder="$t('input')" disabled></Input>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('hc_amt')" prop="hc_amt">
                            <Input v-model="formData.hc_amt">
                                <span slot="append">{{$t('price_unit')}}</span>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem>
                            <Checkbox v-model="formData.jb_show_diff" true-value="1" false-value="0">{{$t('jb_show_diff')}}</Checkbox>
                        </FormItem>
                    </Col>
                </Row>
                <Row v-if="org_level == 3">
                    <Col span="12" >
                      <FormItem :label="$t('show_day_qty')" prop="show_day_qty">
                        <Input v-model="formData.show_day_qty">
                          <span slot="append">{{$t('day')}}</span>
                        </Input>
                      </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('order_remark1')" prop="order_remark1">
                            <Input v-model="formData.order_remark1" type="textarea" :autosize="{minRows: 7,maxRows: 10}"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('order_remark2')" prop="order_remark2" >
                            <Input v-model="formData.order_remark2" type="textarea" :autosize="{minRows: 7,maxRows: 10}"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="formData.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="formData.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="formData.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="formData.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                op: '',
                relist: false,
                org_cname: '',
                org_level: '',
                formData: {
                    hc_amt: '0', // 换卡费用
                    jb_show_diff: '0', // 交班时显示应收
                    order_remark1:'',
                    order_remark2:'',
                    show_day_qty:'',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    hc_amt: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                },
                info: {}
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;

            this.info = JSON.parse(this.$base.getRequest().data)
            this.org_cname = `${this.info.org_cname} [${this.info.org_level_cdesc}]`;
            this.org_level = this.info.org_level;

            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                var data = {
                    org_id:this.info.org_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org/before-setup",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData, data.setup_info);
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                var url = 'org/setup';
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })

            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/info/info_setup.vue